export default function Marquee() {
  const items = ["UNOBSTRUCTED VIEW", "UNCOMPROMISED SAFETY", "CHILD & PET SAFE", "RUST-FREE STEEL", "10 YEAR WARRANTY"];
  const row = [...items, ...items];
  return (
    <section className="py-6 bg-steel-900 overflow-hidden select-none" data-testid="marquee" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-black text-3xl md:text-5xl tracking-tighter text-outline mx-6" style={{ WebkitTextStroke: "1.2px rgba(255,255,255,0.5)", color: "transparent" }}>
              {t}
            </span>
            <span className="text-steel-400 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
